import React from "react";
import { NavLink } from "react-router-dom";
import ThreeKit_Logo from "../../assets/images/ThreeKit_Logo.png";
import ThreeKit_Logo_Wide from "../../assets/images/ThreeKit_Logo_Wide.png";
import { HeaderColumn, HeaderContainer } from "../styled/header";

const Header = ({
  leftColumn,
  leftJustify = true,
  rightColumn,
  rightJustify = true,
  settings = { logo: "center" },
  mobileSettings = { logo: "center" }
}) => {
  return (
    <HeaderContainer id="header-container">
      <HeaderColumn id="header-column-left" position={1} justify={leftJustify}>
        {leftColumn ? leftColumn : null}
      </HeaderColumn>
      <HeaderColumn id="header-column-center" position={2} justify={true}>
        <NavLink to={"/"}>
          <img
            src={ThreeKit_Logo_Wide}
            alt="ThreeKit"
            className="header-logo-img-wide"
            justify={true}
          />
          <img
            src={ThreeKit_Logo}
            alt="ThreeKit"
            className="header-logo-img-icon"
          />
        </NavLink>
      </HeaderColumn>
      <HeaderColumn
        id="header-column-right"
        position={3}
        justify={rightJustify}
      >
        {rightColumn ? rightColumn : null}
      </HeaderColumn>
    </HeaderContainer>
  );
};

export default Header;
